<template>
    <b-card
        class="apprentice-simple-card-with-banner module-card"
        no-body>
        <b-card-img
            class="module-banner banner"
            :src="moduleIn.getBanner()"></b-card-img>

        <div class="module-header">
            <slot name="header"></slot>
        </div>
        <b-card-body body-class="module-card-body body">
            <b-card-title title-tag="h5">
                {{ moduleIn.title }}
                <div
                    class="tag"
                    v-for="tag in moduleIn.module_tags"
                    :key="tag.id">
                    <i
                        class="fas fa-fw fa-circle"
                        :style="{ color: tag.color }"></i
                    >{{ tag.name }}
                </div>
            </b-card-title>
            <div class="module-card-description muted-text">
                {{ moduleIn.description | editor_text_preview(20) }}
                <span
                    class="load-more btn-show-all"
                    v-if="hasContentToPreview()"
                    >{{ $t('common.more') }}</span
                >
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'design-2021-module-card-component',
    props: {
        moduleIn: Object,
        tagsIn: {
            type: Array,
            default: function () {
                return [];
            },
        },
        educationLevelsIn: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            module: null,
        };
    },
    methods: {
        hasContentToPreview() {
            const previewText = this.$options.filters.editor_text_preview(this.moduleIn.description, 20);
            return previewText.split(' ').length > 20;
        },
    },
};
</script>

<style scoped lang="scss">
.module-card {
    .module-header {
        position: absolute;
        top: map-get($grid-gutter-spacing, 'eight');
        right: map-get($grid-gutter-spacing, 'twenty-one');

        .actions {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            div:not(:last-child) {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }

            .btn:before {
                margin-right: 0;
            }
        }
    }

    .module-banner {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .body {
        background-color: $secondary-background-color;
    }
}

.tag {
    font-size: 0.8125rem;
    color: $text-muted-color;
    text-align: right;
    margin-top: map-get($grid-gutter-spacing, 'eight');

    i {
        margin-right: map-get($grid-gutter-spacing, 'eight');
        font-size: 0.625rem;
    }
}

.load-more {
    font-size: $default-font-size;
    font-weight: $font-weight-bold;
    color: $nav-link-color;
    margin-top: map-get($grid-gutter-spacing, 'eight');
    display: flex;
    justify-content: flex-end;
}
</style>
